// Localização: frontend/src/components/Prontuario/Modals/EditarDocumentoModal.jsx (versão 0.1.0)

import React, { useState, useEffect } from 'react';
import Modal from '../../UI/Modal';
import PrimaryButton from '../../Common/PrimaryButton';

const CATEGORIAS = [
    { value: '', label: 'Sem categoria' },
    { value: 'exame', label: 'Exames' },
    { value: 'receita', label: 'Receitas' },
    { value: 'atestado', label: 'Atestados' },
    { value: 'historico-medico', label: 'Histórico Médico' },
    { value: 'consentimento', label: 'Consentimentos' },
    { value: 'identidade', label: 'Identidade' },
    { value: 'outro', label: 'Outros' }
];

const EditarDocumentoModal = ({ isOpen, onClose, documento, onSave }) => {
    const [titulo, setTitulo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [categoria, setCategoria] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [erro, setErro] = useState('');

    useEffect(() => {
        if (documento) {
            setTitulo(documento.titulo || '');
            setDescricao(documento.descricao || '');
            setCategoria(documento.categoria || '');
        }
    }, [documento]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro('');

        // Validações
        if (!titulo.trim()) {
            setErro('O título é obrigatório.');
            return;
        }

        if (titulo.trim().length < 3) {
            setErro('O título deve ter pelo menos 3 caracteres.');
            return;
        }

        if (titulo.trim().length > 255) {
            setErro('O título não pode ter mais de 255 caracteres.');
            return;
        }

        if (descricao.length > 1000) {
            setErro('A descrição não pode ter mais de 1000 caracteres.');
            return;
        }

        setIsSaving(true);
        try {
            await onSave(documento.id, {
                titulo: titulo.trim(),
                descricao: descricao.trim() || null,
                categoria: categoria || null
            });
        } catch (error) {
            setErro(error?.response?.data?.message || 'Erro ao atualizar documento.');
        } finally {
            setIsSaving(false);
        }
    };

    const handleClose = () => {
        if (!isSaving) {
            setErro('');
            onClose();
        }
    };

    if (!documento) return null;

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title="Editar Documento" size="lg">
            <form onSubmit={handleSubmit} className="space-y-4">
                {/* Informação do arquivo (read-only) */}
                <div className="bg-gray-50 p-3 rounded-lg">
                    <p className="text-sm text-gray-600">
                        <span className="font-medium">Arquivo:</span> {documento.nome_arquivo}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                        O arquivo não pode ser alterado. Para trocar o arquivo, delete este documento e faça um novo upload.
                    </p>
                </div>

                {/* Título */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Título <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={titulo}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 255) {
                                setTitulo(value);
                                setErro('');
                            }
                        }}
                        disabled={isSaving}
                        placeholder="Ex: Exame de Sangue - Janeiro 2024"
                        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                            erro && !titulo.trim() 
                                ? 'border-red-300 focus:ring-red-500' 
                                : 'border-gray-300 focus:ring-emerald-500'
                        }`}
                        maxLength={255}
                        required
                    />
                    <p className="mt-1 text-xs text-gray-500">
                        {titulo.length}/255 caracteres
                    </p>
                </div>

                {/* Descrição */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Descrição (opcional)
                    </label>
                    <textarea
                        value={descricao}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 1000) {
                                setDescricao(value);
                            }
                        }}
                        disabled={isSaving}
                        placeholder="Descrição adicional do documento..."
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
                        maxLength={1000}
                    />
                    <p className="mt-1 text-xs text-gray-500">
                        {descricao.length}/1000 caracteres
                    </p>
                </div>

                {/* Categoria */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Categoria (opcional)
                    </label>
                    <select
                        value={categoria}
                        onChange={(e) => setCategoria(e.target.value)}
                        disabled={isSaving}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 bg-white"
                    >
                        {CATEGORIAS.map(cat => (
                            <option key={cat.value} value={cat.value}>{cat.label}</option>
                        ))}
                    </select>
                </div>

                {/* Mensagem de erro */}
                {erro && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                        {erro}
                    </div>
                )}

                {/* Botões */}
                <div className="flex justify-end gap-3 pt-4 border-t">
                    <PrimaryButton
                        type="button"
                        variant="secondary"
                        onClick={handleClose}
                        disabled={isSaving}
                    >
                        Cancelar
                    </PrimaryButton>
                    <PrimaryButton
                        type="submit"
                        disabled={isSaving || !titulo.trim()}
                    >
                        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
                    </PrimaryButton>
                </div>
            </form>
        </Modal>
    );
};

export default EditarDocumentoModal;

